import SvgIcon from '@material-ui/core/SvgIcon';
import * as React from "react";

export function DropIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M17.235 6.184C14.975 3.271 12.683.868 12.66.844L12 .154l-.66.69a77.2 77.2 0 00-4.575 5.34c-3.091 3.986-4.659 7.005-4.659 8.971 0 4.792 4.438 8.691 9.894 8.691s9.894-3.899 9.894-8.69c0-1.967-1.568-4.986-4.66-8.972z" />
        </SvgIcon>
    );
}